if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    $("input[name=_url_source]").attr("name", "url_source");

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));
    
    $('.sym-slides').on('init', function (e, slick) {
        if (slick.options.progressbar) {
            if (slick.options.appendProgressbar && $(slick.options.appendProgressbar).length > 0) {
                $(slick.options.appendProgressbar).append(
                    `<div class="slick-progressbar animate" style="animation-duration: ${slick.options.autoplaySpeed}ms;">progressbar</div>`,
                )
            } else {
                $(this).append(
                    `<div class="slick-progressbar animate" style="animation-duration: ${slick.options.autoplaySpeed}ms;">progressbar</div>`,
                )
            }
        }
    })

    $('.sym-slides').on('beforeChange', function (e, slick) {
        if (slick.options.progressbar) {
            if (slick.options.appendProgressbar && $(slick.options.appendProgressbar).length > 0) {
                $(slick.options.appendProgressbar).find('.slick-progressbar').removeClass('animate');
            } else {
                $('.slick-progressbar', e.target).removeClass('animate')
            }
        }
    })

    $('.sym-slides').on('afterChange', function (e, slick) {
        if (slick.options.appendProgressbar && $(slick.options.appendProgressbar).length > 0) {
            $(slick.options.appendProgressbar).find('.slick-progressbar').addClass('animate');
        } else {
            $('.slick-progressbar', e.target).addClass('animate')
        }
    })

    $('.sym-slides').slick({
        accessibility: false
    });

    $('.slider-redisign-js').slick({
        accessibility: false
    });

    //Dots Function
    $('.js-slick-dots').each((i, dots) => {
        $('button', dots).click((e) => {
            let slideTo = $(e.currentTarget).data('goto');
            $(dots).closest('.slider-redisign-js').slick('slickGoTo', slideTo);
        });
    });

    // Arrows Function
    $(".slider-redesign .slick-prev").click(function(e){
        const $curSlider = $(this).data('target') ? $($(this).data('target')) : $(this).closest('.slider-redisign-js');
		$curSlider.slick('slickPrev');
    });

    $(".slider-redesign  .slick-next").click(function(e){
        const $curSlider = $(this).data('target') ? $($(this).data('target')) : $(this).closest('.slider-redisign-js');
		$curSlider.slick('slickNext');

    });

    $(".slider-text .slick-prev").click(function(e){
        const $curSlider = $(this).data('target') ? $($(this).data('target')) : $(this).closest('.slider-redisign-js');
		$curSlider.slick('slickPrev');
    });

    $(".slider-text  .slick-next").click(function(e){
        const $curSlider = $(this).data('target') ? $($(this).data('target')) : $(this).closest('.slider-redisign-js');
		$curSlider.slick('slickNext');

    });
    


})();

// function success_form_id_712(){
    
//     $.post( "/ajax/functions.php?operation=salesForceLeads", {
//         "oid": "00D8c00000170dL", 
//         "retURL": "https://www.reunioncay.com/",
//         "first_name": $("input[name=first_name]").val(),
//         "last_name": $("input[name=last_name]").val(),
//         "phone": $("input[name=phone]").val(),
//         "email": $("input[name=email_address]").val(),
//         "00N8c00000FwLzO": ($("input[name^=i_d_like_to_receive_information_about_]").eq(0).is(':checked') ? "HOME OWNERSHIP" : "" ) + ", " +
//                             ( + $("input[name^=i_d_like_to_receive_information_about_]").eq(1).is(':checked') ? "INVESTMENT OPPORTUNITIES" : "" ) + ", " +
//                             ( + $("input[name^=i_d_like_to_receive_information_about_]").eq(2).is(':checked') ? "MARINA" : "" ),
//     }, function(data){

//     }, "json" );

// }